import styled from 'styled-components'
import * as React from 'react'
import { DropdownOptions } from 'react-materialize/lib/Dropdown'

interface SelectOptions {
  classes?: string
  dropdownOptions?: DropdownOptions
}

type SelectProps = {
  id?: string
  label?: string
  multiple?: boolean
  options?: SelectOptions
  value?: string
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void
  noLayout?: boolean
  disabled?: boolean
  icon?: React.ReactNode
  validate?: boolean
  success?: string
  error?: string
  browserDefault?: boolean
}

export const Select = styled.select<SelectProps>`
  display: block;
  background: transparent;
  border: none;
  border-bottom: 1px solid #9e9e9e;
  &:hover,
  &:active,
  &:focus,
  &:focus {
    box-shadow: none;
    outline: none;
  }
`

export const Label = styled.label`
  font-size: 13px;
  color: #707070;
`

export const Container = styled.div`
  padding: 1rem;
`

type MessageProps = {
  error: boolean
}

export const Message = styled.p<MessageProps>`
  color: black;
`
